<template>
  <KioskSplashLayout :class="$rounds.optionsWrapper">
    <div :class="$rounds.optionsButtons">
      <BaseButton
        :class="[
          $rounds.kioskRoundButton,
          $rounds.kioskRoundButtonWithPaddings
        ]"
        button-style="Round"
        @click="handleNewOrder">
        <span>New Order</span>
      </BaseButton>
      <BaseButton :class="$rounds.kioskRoundButton"
                  button-style="Round"
                  @click="handlePastOrders">
        <span :class="$style.newLabel">New</span> <span>Past Order Lookup</span>
      </BaseButton>
    </div>
  </KioskSplashLayout>
</template>

<script>
import Component from 'vue-class-component';
import Vue from 'vue';
import { Mutation } from 'vuex-class';
import KioskSplashLayout from '@/layouts/KioskSplashLayout';
import BaseButton from '@/components/BaseButton';
import { SET_PAST_ORDERS_SHOW } from '@/apps/kiosk/store/types';

/* The page with selection of a new order or past order */
@Component({
  components: {
    KioskSplashLayout,
    BaseButton,
  },
})
export default class MainOrderOptions extends Vue {
  @Mutation(SET_PAST_ORDERS_SHOW) setPastOrdersShow;

  handleNewOrder() {
    this.$router.push({ name: 'save-past-orders' });
  }
  handlePastOrders() {
    this.setPastOrdersShow(true);
    this.$router.push({ name: 'number-lookup' });
  }
}
</script>

<style src="@/style/rounds.scss" lang="scss" module="$rounds"></style>

<style lang="scss" module>
@import '~@/style/variables.scss';
.newLabel {
  display: block;
  width: 76px;
  height: 39px;
  background-color: $white;
  border-radius: 19.4px;
  margin-bottom: 6px;
  font-size: 22px;
  line-height: 43px;
  color: $green-color;
  text-transform: uppercase;
}
</style>



// WEBPACK FOOTER //
// src/apps/kiosk/components/MainOrderOptions.vue